<template>
  <el-tabs v-model="activeName" :stretch="true" @tab-click="handleClick" :before-leave="checkTab">
    <el-tab-pane label="GLOBE/TM" name="first" :theType="theType">

      <div class="recharge_hurg">
        <div class="title">选择Globe话费面额</div>
        <ul>
          <li :class="[item.id == status ? 'bechoice':'']" v-for="(item,index) in globe.huaf" :key="index"
            @click="choicePrice(item.id,item.count,item.desc,item.combination)">
            <div>
              ₱{{item.count}}
            </div>
          </li>
        </ul>
      </div>

      <div class="recharge_hurg">
        <div class="title">选择Globe流量套餐</div>
        <div class="wrap_select" v-if="globe.wifiliul && globe.wifiliul.length > 0">
          <el-tabs v-model="activeName_child" :stretch="true" @tab-click="handleClick" class="el-tabs-child">
            <el-tab-pane label="流量套餐" name="list1">
              <ul>
                <!-- 数量小于等于9时，直接显示。多余的隐藏 -->
                <li :class="[item.id == status ? 'bechoice':'']" v-if="index<9" v-for="(item,index) in globe.liul"
                  :key="index" @click="choicePrice(item.id,item.count,item.desc,item.combination)">
                  <!-- 这里的3个属性，是在循环时加载的，如何加入props传递过来的属性？//不用传入属性直接修改即可 -->
                  <div>
                    ₱{{item.count}}
                  </div>
                  <div class="des">
                    {{item.sub_title}}
                  </div>
                </li>
                <li :class="[item.id == status ? 'bechoice':'']" v-if="more && index>=9"
                  v-for="(item,index) in globe.liul" :key="index"
                  @click="choicePrice(item.id,item.count,item.desc,item.combination)">
                  <div>
                    ₱{{item.count}}
                  </div>
                  <div class="des">
                    {{item.sub_title}}
                  </div>
                </li>
              </ul>
              <div v-if="globe.liul && globe.liul.length > 9">
                <div v-if="more" class="more" @click="changeType">
                  <div>点击隐藏更多套餐
                    <img class="arrowBottom arrowTop " src="/static/images/aroowbottom.png" alt="">
                  </div>
                </div>
                <div v-else class="more" @click="changeType">
                  <div>点击显示更多套餐
                    <img class="arrowBottom " src="/static/images/aroowbottom.png" alt="">
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="WiFi套餐" name="list2">
              <ul>
                <!-- 数量小于等于9时，直接显示。多余的隐藏 -->
                <li :class="[item.id == status ? 'bechoice':'']" v-if="index<9" v-for="(item,index) in globe.wifiliul"
                  :key="index" @click="choicePrice(item.id,item.count,item.desc,item.combination)">
                  <!-- 这里的3个属性，是在循环时加载的，如何加入props传递过来的属性？//不用传入属性直接修改即可 -->
                  <div>
                    ₱{{item.count}}
                  </div>
                  <div class="des">
                    {{item.sub_title}}
                  </div>
                </li>

                <li :class="[item.id == status ? 'bechoice':'']" v-if="more && index>=9"
                  v-for="(item,index) in globe.wifiliul" :key="index"
                  @click="choicePrice(item.id,item.count,item.desc,item.combination)">
                  <div>
                    ₱{{item.count}}
                  </div>
                  <div class="des">
                    {{item.sub_title}}
                  </div>

                </li>
              </ul>
              <div v-if="globe.wifiliul && globe.wifiliul.length > 9">
                <div v-if="more" class="more" @click="changeType">
                  <div>点击隐藏更多套餐
                    <img class="arrowBottom arrowTop " src="/static/images/aroowbottom.png" alt="">
                  </div>

                </div>
                <div v-else class="more" @click="changeType">
                  <div>点击显示更多套餐
                    <img class="arrowBottom " src="/static/images/aroowbottom.png" alt="">
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>

        <ul v-else>
          <li :class="[item.id == status ? 'bechoice':'']" v-for="(item,index) in globe.liul" :key="index"
            @click="choicePrice(item.id,item.count,item.desc,item.combination)">
            <div>
              ₱{{item.count}}
            </div>
            <div class="des">
              {{item.sub_title}}
            </div>
          </li>
        </ul>
      </div>

    </el-tab-pane>
    <el-tab-pane label="SMART/TNT" name="second">
      <div class="recharge_hurg">
        <div class="title"> 选择SMART/TNT话费面额</div>
        <ul>
          <li :class="[item.id == status ? 'bechoice':'']" v-for="(item,index) in smart.huaf" :key="index"
            @click="choicePrice(item.id,item.count,item.desc,item.combination)">
            <!-- 这里的3个属性，是在循环时加载的，如何加入props传递过来的属性？//不用传入属性直接修改即可 -->
            <div>
              ₱{{item.count}}
            </div>
          </li>
        </ul>
      </div>

      <div class="recharge_hurg">
        <div class="title">选择SMART/TNT流量套餐</div>
        <div class="wrap_select" v-if="smart.wifiliul && smart.wifiliul.length > 0">
          <el-tabs v-model="activeName_child" :stretch="true" @tab-click="handleClick" class="el-tabs-child">
            <el-tab-pane label="流量套餐" name="list1">
              <ul>
                <!-- 数量小于等于9时，直接显示。多余的隐藏 -->
                <li :class="[item.id == status ? 'bechoice':'']" v-if="index<9" v-for="(item,index) in smart.liul"
                  :key="index" @click="choicePrice(item.id,item.count,item.desc,item.combination)">
                  <!-- 这里的3个属性，是在循环时加载的，如何加入props传递过来的属性？//不用传入属性直接修改即可 -->
                  <div>
                    ₱{{item.count}}
                  </div>
                  <div class="des">
                    {{item.sub_title}}
                  </div>
                </li>

                <li :class="[item.id == status ? 'bechoice':'']" v-if="more && index>=9"
                  v-for="(item,index) in smart.liul" :key="index"
                  @click="choicePrice(item.id,item.count,item.desc,item.combination)">
                  <div>
                    ₱{{item.count}}
                  </div>
                  <div class="des">
                    {{item.sub_title}}
                  </div>

                </li>
              </ul>
              <div v-if="smart.liul && smart.liul.length > 9">
                <div v-if="more" class="more" @click="changeType">
                  <div>点击隐藏更多套餐
                    <img class="arrowBottom arrowTop " src="/static/images/aroowbottom.png" alt="">
                  </div>
                </div>
                <div v-else class="more" @click="changeType">
                  <div>点击显示更多套餐
                    <img class="arrowBottom " src="/static/images/aroowbottom.png" alt="">
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="WiFi套餐" name="list2">
              <ul>
                <!-- 数量小于等于9时，直接显示。多余的隐藏 -->
                <li :class="[item.id == status ? 'bechoice':'']" v-if="index<9" v-for="(item,index) in smart.wifiliul"
                  :key="index" @click="choicePrice(item.id,item.count,item.desc,item.combination)">
                  <!-- 这里的3个属性，是在循环时加载的，如何加入props传递过来的属性？//不用传入属性直接修改即可 -->
                  <div>
                    ₱{{item.count}}
                  </div>
                  <div class="des">
                    {{item.sub_title}}
                  </div>
                </li>

                <li :class="[item.id == status ? 'bechoice':'']" v-if="more && index>=9"
                  v-for="(item,index) in smart.wifiliul" :key="index"
                  @click="choicePrice(item.id,item.count,item.desc,item.combination)">
                  <div>
                    ₱{{item.count}}
                  </div>
                  <div class="des">
                    {{item.sub_title}}
                  </div>
                </li>
              </ul>
              <div v-if="smart.wifiliul && smart.wifiliul.length > 9">
                <div v-if="more" class="more" @click="changeType">
                  <div>点击隐藏更多套餐
                    <img class="arrowBottom arrowTop " src="/static/images/aroowbottom.png" alt="">
                  </div>
                </div>
                <div v-else class="more" @click="changeType">
                  <div>点击显示更多套餐
                    <img class="arrowBottom " src="/static/images/aroowbottom.png" alt="">
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>

        <ul v-else>
          <li :class="[item.id == status ? 'bechoice':'']" v-for="(item,index) in smart.liul" :key="index"
            @click="choicePrice(item.id,item.count,item.desc,item.combination)">
            <div>
              ₱{{item.count}}
            </div>
            <div class="des">
              {{item.sub_title}}
            </div>
          </li>
        </ul>
      </div>
    </el-tab-pane>

    <el-tab-pane label="DITO" name="four">
      <div class="recharge_hurg">
        <div class="title"> 选择DITO话费面额</div>
        <ul>
          <li :class="[item.id == status ? 'bechoice':'']" v-for="(item,index) in dito.huaf" :key="index"
            @click="choicePrice(item.id,item.count,item.desc,item.combination)">
            <div>
              ₱{{item.count}}
            </div>
          </li>
        </ul>
      </div>
      <div class="recharge_hurg">
        <div class="title">选择DITO流量套餐</div>
        <ul>
          <li :class="[item.id == status ? 'bechoice':'']" v-for="(item,index) in dito.liul" :key="index"
            @click="choicePrice(item.id,item.count,item.desc,item.combination)">
            <div>
              ₱{{item.count}}
            </div>
            <div class="des">
              {{item.sub_title}}
            </div>
          </li>
        </ul>
      </div>
    </el-tab-pane>

    <el-tab-pane label="SUN" name="third">
      <div class="recharge_hurg ">
        <div class="title"> 选择SUN话费面额</div>
        <ul>
          <li :class="[item.id == status ? 'bechoice':'']" v-for="(item,index) in sun.huaf" :key="index"
            @click="choicePrice(item.id,item.count,item.desc,item.combination)">
            <!-- 这里的3个属性，是在循环时加载的，如何加入props传递过来的属性？//不用传入属性直接修改即可 -->
            <div>
              ₱{{item.count}}
            </div>
          </li>
        </ul>
      </div>

      <div class="recharge_hurg ">
        <div class="title">选择SUN流量套餐</div>
        <ul>
          <li :class="[item.id == status ? 'bechoice':'']" v-for="(item,index) in sun.liul" :key="index"
            @click="choicePrice(item.id,item.count,item.desc,item.combination)">
            <!-- 这里的3个属性，是在循环时加载的，如何加入props传递过来的属性？//不用传入属性直接修改即可 -->
            <div>
              ₱{{item.count}}
            </div>
            <div class="des">
              {{item.sub_title}}
            </div>
          </li>
        </ul>
      </div>
    </el-tab-pane>

    <el-drawer title="我是标题" :visible.sync="drawer" :with-header="false" :direction="direction" :size="size"
      style="max-width:750px;margin:0 auto;">

      <div class="drawer">
        <div class="drawer-cell ">
          <div class="drawer-cell_hd">充值金额</div>
          <div class="drawer-cell_bd">{{thePrice}}</div>
        </div>
        <div class="drawer-cell ">
          <div class="drawer-cell_hd">实付金额</div>
          <div class="drawer-cell_bd">{{codemoney?codemoney:thePrice}}</div>
        </div>
        <div class="drawer-cell under-line">
          <div class="drawer-cell_hd">手机号码</div>
          <div class="drawer-cell_bd redclass">{{theNumber!='NaN'?theNumber:"请输入手机号码充值"}}</div>
        </div>
        <div class="drawer-cell">
          <div class="drawer-cell_hd">服&ensp;务&ensp;商</div>
          <div class="drawer-cell_bd">{{operators}}</div>
        </div>
        <div class="drawer-cell" style="color: #c82f08;text-align: left;" v-if="combination">
          重要提示：此为组合套餐，失败将退款到余额
        </div>
        <div class="drawer-cell" style="color: #c82f08;text-align: left;" v-if="!combination && radio==2">
          重要提示：使用余额支付，失败将退款到余额
        </div>
        <div class="drawer-cell" style="height:auto" v-if="theNumber!='NaN'">
          <div class="drawer-cell_hd">

            优&ensp;惠&ensp;码
          </div>
          <div class="drawer-cell_bd intro flex">
            <el-input v-model="code" placeholder="请输入优惠代码" size="small" maxlength="12" class='mar-right-5'
              v-if="codetoken==''"></el-input>
            <el-button type="primary" size="mini" plain @click="verificationcodefun" v-if="codetoken==''">确 认
            </el-button>
            <div class='mar-right-5 xcode' v-if="codetoken!=''">{{code}}</div>
          </div>
        </div>

        <div class="drawer-cell" style="height:auto">
          <div class="drawer-cell_hd">套餐介绍</div>
          <div class="drawer-cell_bd intro ">{{theDetail}}</div>
        </div>

        <div class="drawer-cell">
          <div class="drawer-cell_hd">支付方式</div>
          <!-- 余额支付 -->
          <div class="myredioBox" v-if="combination">
            <div class="myredioleabl">
              <div class="myrediotext">在线支付</div>
              <div class="myredio">
                <div></div>
              </div>
            </div>
            <div class="myredioleabl myredioleablAc">
              <div class="myrediotext">余额支付</div>
              <div class="myredio">
                <div></div>
              </div>
            </div>
          </div>
          <!-- 在线支付 -->
          <div class="myredioBox" v-else>
            <div class="myredioleabl" :class="radio==1?'myredioleablAc':''" @click="checkedValuefun(1)">
              <div class="myrediotext">在线支付</div>
              <div class="myredio">
                <div></div>
              </div>
            </div>
            <div class="myredioleabl" :class="radio==2?'myredioleablAc':''" @click="checkedValuefun(2)"
              v-if="codetoken=='' && isLogin">
              <div class="myrediotext">余额支付</div>
              <div class="myredio">
                <div></div>
              </div>
            </div>
          </div>
        </div>

        <div class="btn-area" v-if="theNumber!='NaN'">
          <el-row>
            <el-col :span="12">
              <div class="grid-content bg-purple">
                <el-button type="info" class="half" @click="closeDrawer">取消支付</el-button>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <el-button type='primary' @click="order" v-loading.fullscreen.lock="fullscreenLoading"
                  class="half">确认支付</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-drawer>

    <el-dialog title="请使用扫码支付" :visible.sync="centerDialogVisible" width="300px" center>
      <div>
        <!--  <span>需要注意的是内容是默认不居中的</span> -->
        <vue-qr :text="downloadData.url" :margin="10" colorDark="#000" colorLight="#fff" :dotScale="1"
          :logoSrc="downloadData.icon" :logoScale="0.2" :size="200"></vue-qr>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="centerDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

  </el-tabs>

</template>

<script>
  const delay = (function() {
    let timer = 0
    return function(callback, ms) {
      clearTimeout(timer)
      timer = setInterval(callback, ms)
    }
  })()

  import vueQr from 'vue-qr'
  import wx from 'weixin-js-sdk';

  export default {
    name: 'tabs',
    components: {
      vueQr,
      wx
    },
    data() {
      return {
        magatype: "",
        more: false,
        code: "",
        isLogin: false,
        codemoney: 0,
        codestatus: true,
        codetoken: "",
        radio: 1,
        centerDialogVisible: false,
        downloadData: {
          url: '', //需要转化成二维码的网址
          // icon: require('./xxx.jpg')  //二维码中间的图片,可以不设置
        },
        activeName: "first",
        activeName_child: "list1",
        direction: "btt",
        drawer: false,
        thePrice: 10,
        status: 0,
        theDetail: "",
        combination: null,
        size: "55%",
        theNumber: "NaN",
        operators: "NaN",
        opertaorsId: 1,
        tabValue: true,
        ispay: false,
        i: 0,
        fullscreenLoading: false,
        tag: true
      }
    },
    props: {
      theType: Object,
      globe: Object,
      smart: Object,
      sun: Object,
      tm: Object,
      dito: Object,
    },
    computed: {
      tabStatusChanged() {
        return this.$store.state.tabStatus;
      }
    },
    watch: {
      code(n, o) {
        this.code = this.code.toUpperCase();
      },
      tabStatusChanged(now) {
        if (now <= 0) {
          this.status = now;
        }
      },
      // 父组件通过PROPS（theType）传值到子组件，通过watch监控props值改变，修改相对应的值
      //**如果PROPS为OBJ，WATCH无法监控其属性,因为在父组件时，修改的是其属性。而对象未发生改变**
      theType() {
        this.theNumber = this.theType.number;
        this.tabValue = this.theType.value;
        this.i = 0;
        switch (this.theType.id) {
          case 1:
            this.activeName = "first";
            this.opertaorsId = 1;
            this.operators = "GLOBE/TM";
            break;
          case 2:
            this.activeName = "second";
            this.opertaorsId = 2;
            this.operators = "SMART/TNT";
            break;
          case 3:
            this.activeName = "third";
            this.opertaorsId = 3;
            this.operators = "SUN";
            break;
          case 4:
            this.activeName = "four";
            this.opertaorsId = 4;
            this.operators = "DITO";
            break;
        }
      }
    },
    mounted() {
      let auth_token = localStorage.getItem('auth_token');
      if (auth_token) {
        this.isLogin = true;
      }
    },
    methods: {
      changeType() {
        var that = this;
        if (this.more) {
          this.more = false;
        } else {
          this.more = true;
        }
      },
      onloadcode() {
        this.codemoney = 0;
        this.code = "";
        this.codestatus = true;
        this.codetoken = "";
      },
      verificationcodefun() {
        if (this.combination) {
          this.$message({
            message: "不支持当前套餐",
            type: "warning"
          })
          return false;
        }
        if (this.radio == 2) {
          this.$message({
            message: "不支持当前支付方式",
            type: "warning"
          })
          return false;
        }
        if (this.code) {
          this.$api
            .request('Order/verifyPromoCode', {code: this.code, money: this.thePrice})
            .then(({ data }) => {
                this.codestatus = false;
                this.codemoney = data.codemoney;
                this.codetoken = data.codetoken;
            })
            .catch(error => {
              this.$message({
                message: error,
                type: "warning"
              })
            });
        } else {
          this.$message({
            message: "请输入优惠代码",
            type: "warning"
          })
        }
      },
      checkedValuefun(e) {
        this.radio = e;
      },
      order() {
        if (!this.isLogin && this.radio == 2) {
            this.$message({
              message: "未登录不能使用余额支付",
              type: "warning"
            })
            return false;
        }
        if (this.radio == 1 && this.combination) {
            this.$message({
              message: "组合套餐不能使用在线支付",
              type: "warning"
            })
            return false;
        }
        this.$api.request('Order/create', {
            type: this.radio,
            phone: this.theNumber,
            itemid: this.status,
            client: this.$client,
            code: this.code,
            codetoken: this.codetoken
           })
          .then(({ data }) => {
            this.drawer = false;
            if (data.result == true) {
              this.$message({
                message: "余额支付成功！",
                type: "success"
              })
            } else {
              switch(this.$client) {
               case 'h5':
                  switch (data.type) {
                    case "1":
                      this.downloadData.url = data.result.data.content;
                      break;
                    case "2":
                      this.downloadData.url = data.result.results.qrcode;
                      break;
                    default:
                      this.$message({
                        message: "暂不支持的支付类型！",
                        type: "warning"
                      })
                      break;
                  }
                  this.centerDialogVisible = true;
                  delay(() => {
                    this.checkorder(data.result.results.out_trade_no)
                  }, 3000)
                  break;
               case 'wxh5':
                  switch (data.type) {
                    case "1":
                      let params = JSON.parse(data.result.data.content);
                      this.wxpay(params);
                      break;
                    case "2":
                      window.location.href = data.result.results.api_url;
                      break;
                    default:
                      this.$message({
                        message: "暂不支持的支付类型！",
                        type: "warning"
                      })
                      break;
                  }
                  break;
               case 'magapp':
                  this.magpay(data.result);
                  break;
               default:
                  this.$message({
                    message: "暂不支持的客户端！",
                    type: "warning"
                  })
                  break;
              }
            }
          })
          .catch(error => {
            this.$message({
              message: error,
              type: "warning"
            })
          });
      },
      magpay(params) {
        let config = {
          money: params.pay_amount,
          title: params.description,
          des: params.description,
          payWay: {
            // wallet: 1,
            weixin: 1,
            alipay: 1,
          },
          orderNum: params.oid,
          unionOrderNum: params.order_sn,
          type: params.description
        };
        mag.pay(config, () => {
          setTimeout(() => {
            this.$message({
              message: "支付成功",
              type: "warning"
            })
          }, 50);
        }, () => {
          this.$message({
            message: "支付失败",
            type: "warning"
          })
        });
      },
      wxpay(params) {
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            'appId': params.appId,
            'timeStamp': params.timeStamp,
            'nonceStr': params.nonceStr,
            'package': params.package,
            'signType': params.signType,
            'paySign': params.sign
          },
          (res) => {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              this.$message({
                message: "支付成功",
                type: "warning"
              })
              this.$router.go(0);
            } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
            } else if (res.err_msg === 'get_brand_wcpay_request:fail') {
              this.$router.go(0);
            }
        });
      },
      checkorder(sn) {
        this.$api
          .request('Order/check', {sn})
          .then(({ data }) => {
              this.$message({
                message: "支付成功",
                type: "warning"
              })
              this.$router.go(0);
          })
          .catch(error => {
            console.log(error)
          });
      },
      closeDrawer() {
        this.drawer = false
      },
      // 切换TABS前，进行判断，当前运营商（activename）与this.type.id是否一致？？？
      // XXXX需要的是在正确的条状一次后，禁止掉后续的跳转(不可行，因为在)
      checkTab(act, oact) {
        this.$store.commit('setTab', act);
        //在跳转之前进行判断，TABS不可以跳转
        // 当输入号码后进入这段判断
        //接房方法找到原有的，判断，或者INIT原有状态。
        if (act == oact || this.activeName == oact) {
          this.i++
        }
        if (!this.tabValue) {
          // 问题出在这里，tabvalue 需要执行一次。
          //i<1时不执行，i>0时执行

          //新的问题：当前activename即输入号码段时，不用PROPS修改，但是用户又手残去点击了一次。
          // 如何解决？817号段，即号码输入号码就是第一个运营商的（方法错误。）即不需要发生修改运营商

          if (this.i < 1) {
            this.i++;
            return true
          };
          // 弹出error框体

          if (this.i > 0) {
            this.$message({
              message: "号段与运营商需匹配",
              type: "warning"
            })
            return false
          }
        }
        if (!this.tabValue && this.i > 0) {
          this.$message({
            message: "号段与运营商不匹配",
            type: "warning"
          })
          // 问题出在这里，tabvalue 需要执行一次。
          this.i++;
          return false
        }
      },
      handleClick(tab, event) {
      },
      // 弹窗，1、验证（如果可以，禁止点击其他tabs），可点击，判断号码与运营商是否一致。2、装载相应数据。
      choicePrice(index, price, desc, combination) {
        var num = this.theType.number;
        this.status = index;
        this.$store.commit('setTabStatus', index);
        this.$store.commit('setTab2Status', 0);
        var bl = this.common.test(num);
        if (num == "" || num == "NaN" || !num) {
          this.thePrice = price
          this.code = "";
          this.codemoney = 0;
          this.codestatus = true;
          this.codetoken = "";
          this.radio = 1;
          this.drawer = true
          this.theDetail = desc
          this.combination = combination
        } else {
          //判断号码是否为菲律宾号码段，符合10位
          var reg = /^(8|08|9|09)[0-9]{9}$/;
          if (this.common.test(num) && num.match(reg)) {
            this.thePrice = price
            this.code = "";
            this.codemoney = 0;
            this.codestatus = true;
            this.codetoken = "";
            this.drawer = true
            this.theDetail = desc
            this.combination = combination
            if (combination) {
              this.radio = 2;
            } else {
              this.radio = 1;
            }
          } else {
            this.$message({
              message: "请输入正确的菲律宾手机号码",
              type: "warning"
            })
          }
        }
      }
    }
  }
</script>
<style scoped>
  .el-tabs {


    /*       margin-left: 13px;
          margin-right: 13px; */
    /* background-color: #FFFFFF; */
    /*    z-index: 2;
          border-radius: 9px;
          box-shadow: 0 5px 5px #b22830; */
  }

  .myredioBox {
    text-align: right;
    width: 70%;
    color: #666;
    display: flex;
  }

  .myredioleabl {
    height: 2rem;
    line-height: 2rem;
    width: 50%;
  }

  .myrediotext {
    float: right;
  }

  .myredio {
    float: right;
    width: 0.8rem;
    height: 0.8rem;
    background-color: #ffffff;
    border-radius: 0.8rem;
    margin-right: 0.5rem;
    margin-top: 0.6rem;
    border: 1px solid #888888;
  }

  .myredioleabl .myredio {
    border: 1px solid #888888;
  }

  .myredioleablAc .myredio {
    border: 1px solid #b22830;
  }

  .myredioleabl .myredio div {
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 0.6rem;
    margin: 0 auto;
    margin-top: 0.1rem;
    background-color: #FFFFFF;
  }

  .myredioleablAc .myredio div {
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 0.6rem;
    margin: 0 auto;
    margin-top: 0.1rem;
    background-color: #b22830;
  }

  ul {

    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
    display: flex;
    justify-content: center;
    padding: 0;
  }

  ul li {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    list-style-type: none;
    width: 29.5%;
    margin-right: 2%;
    border-radius: 0.15625rem;
    height: 2.5rem;
    text-align: center;
    line-height: 2.5rem;
    margin-bottom: 1rem;
    border: 1px solid var(--theme-color);
    color: #333333;
    position: relative;
  }

  ul li div {
    margin: 0;
    line-height: 1em;
    height: 1em;


  }

  ul li div.bechoice {
    color: #FFFFFF;
  }

  div.des {
    line-height: 1rem;
    height: 1rem;
    font-size: .8em;
    color: #999;

  }

  .bechoice {
    /*border:2px solid #e43;*/
    color: #fff !important;
    background-color: var(--theme-color)
  }

  li.bechoice div.des {
    color: #fff;
  }

  .drawer {
    padding: 20px 20px 0px;
    height: 100%;
    position: relative;

  }

  .drawer .btn-area {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

  }

  .drawer-cell {
    position: relative;
    width: 100%;
    display: flex;
    height: 2em;
    line-height: 2em;
  }

  .drawer-cell.under-line:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 1px;
    color: #e5e5e5;
    border-top: 1px solid #e5e5e5;
    transform: scaleY(.5);
    z-index: 2;
  }

  .drawer-cell_hd,
  .drawer-cell_bd {
    display: inline-block;
  }

  .drawer-cell_hd {
    width: 30%;
    text-align: left;
    color: #333;
  }

  .drawer-cell_bd {
    text-align: left;
    width: 70%;
    color: #666
  }

  .half {
    width: 100%;
  }

  .intro {
    overflow-wrap: break-word;

  }

  .tag {
    position: absolute;
    width: 40px;
    height: 40px;
    top: -25px;
    right: -10px;
  }

  .flex {
    display: flex;
  }

  .mar-right-5 {
    margin-right: 5px;
  }

  .xcode {
    height: 32px;
    line-height: 32px;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    outline: 0;
    padding: 0 15px;
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    width: 100%;
    text-align: left;
  }

  .borderSr {
    border: 1px solid #b22830;
    box-shadow: 0 0 5px #b22830;
    padding: 20px 20px 0;
    z-index: 2;
    border-radius: 9px;
    margin-bottom: 20px;
  }

  .asideShadow {
    box-shadow: 5px 0px 5px -5px black, -5px 0px 5px -5px black;
  }

  .more {
    font-size: 14px;
    color: #b22830;


  }

  .arrowBottom {
    width: 20px;
    height: 11px;
  }

  .arrowTop {
    transform: rotate(180deg);
  }

  .recharge_hurg .title {
    color: #2c3e50;
    font-size: 16px;
  }

  .redclass {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/tabs.vue